/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Moderationtargetreportcount3Inputs */

const en_moderationtargetreportcount3 = /** @type {(inputs: Moderationtargetreportcount3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} reports in total`)
};

const de_moderationtargetreportcount3 = /** @type {(inputs: Moderationtargetreportcount3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Meldungen insgesamt`)
};

/**
* | output |
* | --- |
* | "{count} reports in total" |
*
* @param {Moderationtargetreportcount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationtargetreportcount3 = /** @type {((inputs: Moderationtargetreportcount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationtargetreportcount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationtargetreportcount3(inputs)
	return de_moderationtargetreportcount3(inputs)
});
export { moderationtargetreportcount3 as "moderationTargetReportCount" }